import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@weezevent/nacre';

import Styles from '../../../styles/eventCreation/eventCreation.module.css';

export default function SaveAndRedirectButton({ hideButton, performAction, loading, disabled = false }) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = React.useState(false);
    if (hideButton || !performAction) {
        return null;
    }

    return (
        <>
            <Modal
                open={showModal}
                onClose={() => setShowModal(false)}
                title={t('ticket.creationEvent.noPriceModal.title')}
                submitButton={
                    <Button
                        primary
                        onClick={() => {
                            performAction();
                            setShowModal(false);
                        }}
                        label={t('ticket.common.action.confirm')}
                        disabled={disabled}
                        isLoading={loading}
                    />
                }
                cancelButton={<Button onClick={() => setShowModal(false)} label={t(`ticket.common.action.cancel`)} />}
            >
                {t('ticket.creationEvent.noPriceModal.body')}
            </Modal>
            <Button
                className={Styles['button-save-configure']}
                label={t('ticket.creationEvent.saveAndRedirect')}
                isLoading={loading}
                onClick={() => setShowModal(true)}
                disabled={disabled}
            ></Button>
        </>
    );
}
SaveAndRedirectButton.propTypes = {
    hideButton: PropTypes.bool.isRequired,
    performAction: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    disabled: PropTypes.bool
};
